import React from "react";



export const project_data = [

    {
    title: "Sensors",
    subtitle: "Flexilbe Optical Sensor for Tri-axial Force Measurement",
    description:
      "Designed a flexible, thin, lightweight & transparent optical tactile sensor capable to measuring forces in 3D (normal and shear) for enhanced human robot interaction and collaboration",
    image: "./project-1.png",
    link: "/project1",
    //link: "https://drive.google.com/file/d/1wgzZjDiGsLrIC_kcr5g7VU376saSmMoM/view?usp=sharing",

  },
  {
    title: "Reinforcement Learning",
    subtitle: "Control of Shape Memory Alloy Coiled Spring",
    description:
      "Aimed to control SMA, specifically the position of SMA in coil form by solely using reinforcement learning (RL) in real-time environment (Collaboration with ChrisFugl)",
    image: "./project-4.png",
    link: "/project4",
     //link: "https://github.com/ChrisFugl/Shape-Memory-Alloy-Positioning",
  },
    {
    title: "MEMS",
    subtitle: "Microelectromechanical systems",
    description:
      "Fabricated force sensor using MEMS. Futhermore, trained on the equipment and taught graduate students how to use microelectronics for their research.",
    image: "https://www.pureairemonitoring.com/wp-content/uploads/2020/10/MEMS-Article.jpg",
    link: "/project0",

  },
  {
    title: "Sensor & Actuator",
    subtitle: "Soft Sensor for DEA",
    description:
      "A self-sensing soft tactile actuator based on Dielectric elastomer actuator (DEA) with a transparent tactile sensor for and wearable haptic interfaces. The actuator produces an up to 0.9 N with1.43 mm, while the sensor can measure the force in a range of 0 to 1.25 N under various frequency ranges. (Collaboration with J.H.Y)",
    image: "./project-3.png",
    link: "/project3",
  },
  {
    title: "Rehabilitation Robot",
    subtitle: "Wrist 2 DOF Assistive Robot Using SMA",
    description:
      "Contributed in developing a soft sensorized wearable glove using Shape Memory Alloy (SMA) coiled spring actuator for a wearable assist robot for the wrist. It delivered the required torque and ROM needed during activities of daily living. (Joint project KAIST and CNU Hospital funded by NRF and Ministry of Health and Welfare) ",
    image: "./project-2.png",
    link: "/project2",
        //"https://www.mdpi.com/2076-3417/9/19/4025",
  },
  {
    title: "Soft Robot Actuator",
    subtitle: "Hybrid Actuator for hand rehabilitation",
    description:
      "Developed a bio-inspired hybrid actuator inspired by crustacean exoskeleton by incorporating rigid shells and a soft core. When actuated, the biomimetic actuator was able to produce forces up to 11.5 N at 135 KPa, satisfying the required criteria of 8N for palm grasping. The proposed soft bio-inspired hybrid bending actuator was used as a supernumerary sixth finger for rehabilitation and robot grippers",
    image: "./project-5.png",
    link: "/project5",
    //link: "https://drive.google.com/drive/folders/11DEagDHF3wPuOoOyNKMvtI3CadbwKSAJ?usp=sharing",
  },
];

export const testimonials = [
  {
    quote:
      "I met Ibrahim while we were both international students at Korea Advanced Institute of Science and Technology. We worked together on a project in a class called Intelligent Robotics where Ibrahim exhibited a great enthusiasm for making a highly interesting project that I am still very proud of today. He came up with the idea to train a reinforcement learning agent to control the shape of a memory alloy using an electrical current. Ibrahim was a central part of ensuring that the project succeeded: He took the lead on the mechanical and electrical parts of the project while simultaneously having a firm grib of the software and theoretical parts of the reinforcement learning algorithm. Besides from being a skilled professional, I also found Ibrahim to be a joy to work with since his personality made everyone in the team feel included and he contributed to a fun atmosphere.",
    image: "./Chris.jpg",
    name: "Christoffer Koo Øhrstrøm",
    company: "Data Scientist at Visma",
  },
  {
    quote:
      " I am very lucky to have the lab mate who is as optimistic, assertive and enthusiastic as Ibrahim. He knows what he likes and is very passionate about them. He does not hesitate to help the others and I respect him for that. When it comes to his field of research, he is very experienced and can provide others with practical advice. Also, he is an amazing friend. In times of difficulties i.e. during my thesis preparation, he would encourage me consistently throughout the end which gave me strength to reach the final goal. I owe him for all of that. Ibrahim, I really wish for your success in life.",
    image: "./Hee-Ju.png",
    name: "Hee-Ju Moon",
    company: "HRI Lab, KAIST",
  },
  {
    quote:
      "Through our LFM Programme, I was fortunate enough to work with Ibrahim on two key projects in our manufacturing works. Ibrahim’s passion, energy and relentless commitment proved instrumental in driving the team towards meaningful results. As a human being he has a beautiful soul and I look back at the time spent working together with great affection; wishing him continued success in his future endeavours.",
    image: "./SirAhmed.jpg",
    name: "Muhammad Ahmad Qadri",
    company: "Director at Qadri Group",
  },
  {
    quote:
      "The two words I could come up with about Ibrahim are passionate and patient. \n" +
        "He and I did a project together in the lecture about soft robotics. He reached me first to do the project together and actively worked from start to finish. He was a creative thinker as well as a person who could look at each idea critically to reach the best idea, which I personally think is important for the engineer to develop something that really can help people. He was also a person who could patiently teach others what he is good at. As I was dealing with SMA (shape memory alloy) for the first time in the project, he calmly taught me how to deal with it and encouraged me to do it again even if I did something wrong. Not only did I learn a lot while working on the project with him, but also it was a fortune to get to know him as a fellow researcher and a good friend.",
    image: "./Hwayeong.jpg",
    name: "Hwayeong Jeong",
    company: "PhD. KAIST",
  },

  {
    quote:
      "I worked with Ibrahim during my Bachelor's degree for our final year project. We set an ambitious goal for ourselves, some may say over ambitious, but we spared no effort into trying to achieve it. Ibrahim was there every step of the way and people may find a number of faults with him but I don't think anyone can say he doesn't put in the time and effort. Lastly he is a fun person to work with which brightened up the mood when we found ourselves stuck and banging our heads against the wall.",
    image: "./fahd.jpg",
    name: "Fahd Imtiaz",
    company: "Software Developer at Sedenius Technologies",
  },
];

export const skills = [
  "Mechatronics",
  "Haptics",
  "Soft Robotics",
  "Medical Robotics",
  "MATLAB",
  "Prototyping",
  "COMSOL",
  "MEMS",
  "Python",
];
